/**
 * Build-time coordinates of Personify Health's login (ADR-094 public config),
 * for the signup gate that sends Personify's members there first.
 */

export interface PersonifyConfig {
  readonly clientId: string;
  readonly authorizeUrl: string;
  /** Carried for parity with legacy config; the gate never reads it. */
  readonly sponsorId: string;
}

/**
 * Build-time config (ADR-094). Missing, partial or non-https values turn the
 * gate off rather than sending members somewhere broken.
 */
export function readPersonifyConfig(): PersonifyConfig | null {
  // Literal reads so Next inlines each value at build time.
  const enabled = (process.env.NEXT_PUBLIC_PERSONIFY_ENABLED ?? '').trim();
  const clientId = (process.env.NEXT_PUBLIC_PERSONIFY_CLIENT_ID ?? '').trim();
  const authorizeUrl = (process.env.NEXT_PUBLIC_PERSONIFY_AUTHORIZE_URL ?? '').trim();
  const sponsorId = (process.env.NEXT_PUBLIC_PERSONIFY_SPONSOR_ID ?? '').trim();
  if (enabled !== 'true' || !clientId || !isHttpsUrl(authorizeUrl)) return null;
  return { clientId, authorizeUrl, sponsorId };
}

function isHttpsUrl(value: string): boolean {
  try {
    return new URL(value).protocol === 'https:';
  } catch {
    return false;
  }
}
